import React from "react";
import { useNavigate } from "react-router-dom";
import PageMeta from "../components/PageMeta";
import PageShell from "../components/PageShell";
import {
  BookingCTA,
  CTAButton,
  FeatureCard,
  ProductMockupPanel,
  Section,
  WorkflowStep,
} from "../components/MarketingPrimitives";
import { executionCapabilities, signalCapabilities, workflowColumns } from "../content/siteContent";

const Product = () => {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageMeta
        title="Product | BestSalesCoach.ai"
        description="Explore the BestSalesCoach.ai product: an AI GTM execution platform that connects account signals, stakeholder intelligence, MEDDICC discipline, technical validation, and next-best actions."
        canonicalPath="/product"
      />
      <Section
        id="product-page-hero"
        eyebrow="Product"
        title="AI GTM execution intelligence from account signal to revenue action"
        description="BestSalesCoach.ai helps CROs, founders, and GTM teams connect ICP, account signals, stakeholder intelligence, MEDDICC discipline, technical validation, and next-best actions into one execution layer."
        tone="hero"
      >
        <div className="hero-grid">
          <div>
            <p className="marketing-body-copy">
              BestSalesCoach.ai turns account signals into qualified opportunity action: who to engage, what evidence is missing, what risk exists, and what the team should do next.
            </p>
            <div className="hero-actions">
              <BookingCTA
                eventName="product_demo_click"
                sourcePage="product"
                ctaClicked="product_book_20_min_demo"
                requestedOffer="BestSalesCoach.ai Platform Demo"
                buyerType="GTM Team"
                urlType="demo"
              />
              <CTAButton variant="secondary" onClick={() => navigate("/usecases")}>
                Explore Signal-to-Execution Use Cases
              </CTAButton>
            </div>
          </div>
          <ProductMockupPanel />
        </div>
      </Section>

      <Section
        id="product-workflow"
        eyebrow="How it works"
        title="One platform across signal detection, pipeline execution, and AI coaching"
        description="Bring inputs from CRM, meetings, notes, account signals, and stakeholders into one review surface that helps teams prioritise, act, and learn faster."
        tone="dark"
      >
        <div className="marketing-grid marketing-grid-four">
          {workflowColumns.map((column) => (
            <WorkflowStep key={column.title} {...column} />
          ))}
        </div>
      </Section>

      <Section
        id="product-capabilities"
        eyebrow="Capabilities"
        title="Signal-to-Opportunity"
        description="Build one repeatable flow from account signal to qualified action so GTM teams stop losing context before the opportunity is even understood."
        tone="light"
      >
        <div className="marketing-grid marketing-grid-four">
          {signalCapabilities.map((capability) => (
            <FeatureCard key={capability.title} {...capability} />
          ))}
        </div>
      </Section>

      <Section
        id="product-execution"
        eyebrow="Capabilities"
        title="Opportunity Execution"
        description="Once the right accounts are in motion, help teams inspect, coach, technically validate, and move opportunities forward with more evidence and less noise across Sales, PreSales, RevOps, Customer Success, and founder-led GTM."
        tone="dark"
      >
        <div className="marketing-grid marketing-grid-four">
          {executionCapabilities.map((capability) => (
            <FeatureCard key={capability.title} {...capability} />
          ))}
        </div>
      </Section>
    </PageShell>
  );
};

export default Product;
